import Axios from '@/utils/axios';
import Api from '@/constant/api';

export const getUserInfo = async (params) => {
  return Axios.jsonGet(Api.user.info, { params });
};

export const userRegister = async (body) => {
  return Axios.jsonPost(Api.user.register, body);
};

export const getRegisterCode = async (params) => {
  return Axios.jsonGet(Api.user.register_code, { params });
};

export const userLogin = async (body) => {
  return Axios.jsonPost(Api.user.login, body);
};

export const userLogout = async (params) => {
  return Axios.jsonGet(Api.user.logout, { params });
};

export const userForget = async (body) => {
  return Axios.jsonPost(Api.user.forget, body);
};

export const getForgetCode = async (params) => {
  return Axios.jsonGet(Api.user.forget_code, { params });
};

export const getAccountInfo = async (params) => {
  return Axios.jsonGet(Api.user.account_info, { params });
};

export const getAccountFlow = async (params) => {
  return Axios.jsonGet(Api.user.account_flow, { params });
};
export const withdraw = async (body) => {
  return Axios.jsonPost(Api.user.withdraw, body);
};
